// 대학·전형 예시 (공식 admissions URL만). 합격선·정원 숫자 금지.
// verifiedAt: 링크를 열어 확인한 연월 (YYYY-MM)
// 허브 목록의 원천: universityCatalog.js

export const programExamples = [
  // —— EJU · stem ——
  {
    id: 'hokudai-stem',
    univ: '홋카이도대학',
    facultyHint: '이공·정보 계열 요강 확인 예시',
    track: 'eju',
    field: 'stem',
    admissionUrl: 'https://www.hokudai.ac.jp/admission/',
    notes: '외국인 유학생·학부별 모집요항 링크가 입시 탑에 모여 있음. 연도·학부를 확인.',
    verifiedAt: '2026-08',
  },
  {
    id: 'titech-stem',
    univ: '도쿄과학대학(구 도쿄공업대)',
    facultyHint: '이공·정보',
    track: 'eju',
    field: 'stem',
    admissionUrl: 'https://www.isct.ac.jp/en/admission',
    notes: '유학생·학부 전형 안내는 Admissions에서 학부·전형을 좁혀 요강 PDF를 찾음.',
    verifiedAt: '2026-08',
  },
  {
    id: 'osaka-stem',
    univ: '오사카대학',
    facultyHint: '이공·정보',
    track: 'eju',
    field: 'stem',
    admissionUrl: 'https://www.osaka-u.ac.jp/ja/admissions',
    notes: '입시 안내에서 외국인 유학생·학부 전형을 구분해 최신 요강을 연다.',
    verifiedAt: '2026-08',
  },
  {
    id: 'waseda-stem',
    univ: '와세다대학',
    facultyHint: '이공·정보(사립 예시)',
    track: 'eju',
    field: 'stem',
    admissionUrl: 'https://www.waseda.jp/inst/admission/',
    notes: '학부·유학생 전형별로 요강이 분리됨. 영어 외부시험·EJU 지정회를 표로 대조.',
    verifiedAt: '2026-08',
  },
  {
    id: 'tohoku-stem',
    univ: '도호쿠대학',
    facultyHint: '이공·정보',
    track: 'eju',
    field: 'stem',
    admissionUrl: 'https://admissions.tohoku.ac.jp/ja/',
    notes: 'アドミッション機構에서 학부 선발·유학생 특별선발 요강.',
    verifiedAt: '2026-08',
  },
  {
    id: 'nagoya-stem',
    univ: '나고야대학',
    facultyHint: '이공·정보',
    track: 'eju',
    field: 'stem',
    admissionUrl: 'https://www.nagoya-u.ac.jp/admissions/',
    notes: '사비외국인·학부별 요강을 Admissions에서 연다.',
    verifiedAt: '2026-08',
  },
  {
    id: 'tus-stem',
    univ: '도쿄이과대학',
    facultyHint: '이공(사립)',
    track: 'eju',
    field: 'stem',
    admissionUrl: 'https://www.tus.ac.jp/admissions/',
    notes: '이공 사립. 학부·유학생 전형 요강에서 EJU·영어 요건 확인.',
    verifiedAt: '2026-08',
  },
  // —— EJU · medicine ——
  {
    id: 'utokyo-med',
    univ: '도쿄대학',
    facultyHint: '의계·유학생/입시 확인 예시',
    track: 'eju',
    field: 'medicine',
    admissionUrl: 'https://www.u-tokyo.ac.jp/ja/admissions/index.html',
    notes: '의계는 유학생 특별전형 유무·일반선발만 허용인지 학부 요강에서 먼저 확인.',
    verifiedAt: '2026-08',
  },
  {
    id: 'kyoto-med',
    univ: '교토대학',
    facultyHint: '의계·입시',
    track: 'eju',
    field: 'medicine',
    admissionUrl: 'https://www.kyoto-u.ac.jp/ja/admissions',
    notes: '모집요항·외국인 유학생 안내를 학부별로 대조. 면접·서류 비중을 체크.',
    verifiedAt: '2026-08',
  },
  {
    id: 'hokudai-med',
    univ: '홋카이도대학',
    facultyHint: '의학부 등 보건·의계',
    track: 'eju',
    field: 'medicine',
    admissionUrl: 'https://www.hokudai.ac.jp/admission/',
    notes: '의학부 유학생 전형 실시 여부·과목은 해당 연도 PDF로만 확정.',
    verifiedAt: '2026-08',
  },
  {
    id: 'osaka-med',
    univ: '오사카대학',
    facultyHint: '의계·보건',
    track: 'eju',
    field: 'medicine',
    admissionUrl: 'https://www.osaka-u.ac.jp/ja/admissions',
    notes: '의계 유학생/일반 전형 구분을 입시 안내에서 확인.',
    verifiedAt: '2026-08',
  },
  {
    id: 'okayama-med',
    univ: '오카야마대학',
    facultyHint: '의계·보건',
    track: 'eju',
    field: 'medicine',
    admissionUrl: 'https://www.okayama-u.ac.jp/tp/admission/',
    notes: '의계 전형 실시·과목은 해당 연도 학부 요강으로만 확정.',
    verifiedAt: '2026-08',
  },
  {
    id: 'sapmed-med',
    univ: '삿포로의과대학',
    facultyHint: '의계(공립)',
    track: 'eju',
    field: 'medicine',
    admissionUrl: 'https://web.sapmed.ac.jp/',
    notes: '유학생 특별전형 유무·출원자격을 해당 연도 요강에서만 확정.',
    verifiedAt: '2026-08',
  },
  // —— EJU · humanities ——
  {
    id: 'utokyo-hum',
    univ: '도쿄대학',
    facultyHint: '문과·사회',
    track: 'eju',
    field: 'humanities',
    admissionUrl: 'https://www.u-tokyo.ac.jp/ja/admissions/index.html',
    notes: '종합과목·일본어·영어 제출 요건을 학부 요강 표에서 확인.',
    verifiedAt: '2026-08',
  },
  {
    id: 'keio-hum',
    univ: '게이오의숙대학',
    facultyHint: '문과·사회(사립 예시)',
    track: 'eju',
    field: 'humanities',
    admissionUrl: 'https://www.keio.ac.jp/ja/admissions/',
    notes: '학부·AO/유학생 전형이 나뉨. 영어 성적·소논문·면접 유무를 요강에서 확인.',
    verifiedAt: '2026-08',
  },
  {
    id: 'sophia-hum',
    univ: '조치대학',
    facultyHint: '문과·국제·사회',
    track: 'eju',
    field: 'humanities',
    admissionUrl: 'https://adm.sophia.ac.jp/',
    notes: '입시 전용 사이트에서 학부·유학생·특별입학 요강을 찾음.',
    verifiedAt: '2026-08',
  },
  {
    id: 'hit-hum',
    univ: '히토쓰바시대학',
    facultyHint: '사회과학',
    track: 'eju',
    field: 'humanities',
    admissionUrl: 'https://www.hit-u.ac.jp/admission/',
    notes: '사회과학 중심. 유학생·일반선발 학부 요강에서 과목·영어를 확인.',
    verifiedAt: '2026-08',
  },
  {
    id: 'rikkyo-hum',
    univ: '릿쿄대학',
    facultyHint: '문과·사회(사립)',
    track: 'eju',
    field: 'humanities',
    admissionUrl: 'https://www.rikkyo.ac.jp/admissions/',
    notes: '학부·유학생 전형 요강에서 EJU·영어·면접 요건을 표로 대조.',
    verifiedAt: '2026-08',
  },
  {
    id: 'icu-hum',
    univ: '국제기독교대학(ICU)',
    facultyHint: '문과·국제',
    track: 'eju',
    field: 'humanities',
    admissionUrl: 'https://www.icu.ac.jp/admissions/',
    notes: '국제·리버럴아츠. 전형·언어 요건을 Admissions에서 확인.',
    verifiedAt: '2026-08',
  },
  // —— general ——
  {
    id: 'dnc-general-stem',
    univ: '대학입시센터(DNC)',
    facultyHint: '일반입시·공통테스트(이공 준비 축)',
    track: 'general',
    field: 'stem',
    admissionUrl: 'https://www.dnc.ac.jp/kyotsu/',
    notes: '공통테스트 과목·일정을 먼저 확정한 뒤, 지망 대학 본고사 요강과 맞춘다.',
    verifiedAt: '2026-08',
  },
  {
    id: 'hokudai-general-stem',
    univ: '홋카이도대학',
    facultyHint: '일반선발·이공',
    track: 'general',
    field: 'stem',
    admissionUrl: 'https://www.hokudai.ac.jp/admission/',
    notes: '일반선발 요강에서 공통테스트·개별학력검사 과목을 표로 확인.',
    verifiedAt: '2026-08',
  },
  {
    id: 'kyushu-general-stem',
    univ: '규슈대학',
    facultyHint: '일반선발·이공',
    track: 'general',
    field: 'stem',
    admissionUrl: 'https://www.kyushu-u.ac.jp/ja/admission/',
    notes: '일반선발 학부 요강에서 공통테스트·본고사 과목을 확인.',
    verifiedAt: '2026-08',
  },
  {
    id: 'nagoya-general-stem',
    univ: '나고야대학',
    facultyHint: '일반선발·이공',
    track: 'general',
    field: 'stem',
    admissionUrl: 'https://www.nagoya-u.ac.jp/admissions/',
    notes: '일반선발·개별학력검사 과목은 해당 연도 학부 요강으로.',
    verifiedAt: '2026-08',
  },
  {
    id: 'tsukuba-general-stem',
    univ: '쓰쿠바대학',
    facultyHint: '일반선발·이공',
    track: 'general',
    field: 'stem',
    admissionUrl: 'https://www.tsukuba.ac.jp/admission/',
    notes: '입시 탑에서 일반선발 모집요항·과목표를 연다.',
    verifiedAt: '2026-08',
  },
  {
    id: 'utokyo-general-med',
    univ: '도쿄대학',
    facultyHint: '일반선발·의계',
    track: 'general',
    field: 'medicine',
    admissionUrl: 'https://www.u-tokyo.ac.jp/ja/admissions/index.html',
    notes: '의계 일반선발은 일본 고교 과정 전제가 강한 경우가 많음. 출원자격을 원문으로.',
    verifiedAt: '2026-08',
  },
  {
    id: 'kyoto-general-med',
    univ: '교토대학',
    facultyHint: '일반선발·의계',
    track: 'general',
    field: 'medicine',
    admissionUrl: 'https://www.kyoto-u.ac.jp/ja/admissions',
    notes: '의계 일반선발 요강에서 공통테스트·2차·면접을 확인.',
    verifiedAt: '2026-08',
  },
  {
    id: 'sapmed-general-med',
    univ: '삿포로의과대학',
    facultyHint: '일반선발·의계',
    track: 'general',
    field: 'medicine',
    admissionUrl: 'https://web.sapmed.ac.jp/',
    notes: '공립 의계 일반선발. 출원자격·과목은 해당 연도 요강만.',
    verifiedAt: '2026-08',
  },
  {
    id: 'kumamoto-general-med',
    univ: '구마모토대학',
    facultyHint: '일반선발·의계·보건',
    track: 'general',
    field: 'medicine',
    admissionUrl: 'https://www.kumamoto-u.ac.jp/nyugaku',
    notes: '의계·보건 일반선발 요강에서 과목·일정을 확인.',
    verifiedAt: '2026-08',
  },
  {
    id: 'kyoto-general-hum',
    univ: '교토대학',
    facultyHint: '일반선발·문과',
    track: 'general',
    field: 'humanities',
    admissionUrl: 'https://www.kyoto-u.ac.jp/ja/admissions',
    notes: '일반선발 문과 요강의 공통테스트·2차 과목·조사서를 확인.',
    verifiedAt: '2026-08',
  },
  {
    id: 'hit-general-hum',
    univ: '히토쓰바시대학',
    facultyHint: '일반선발·사회과학',
    track: 'general',
    field: 'humanities',
    admissionUrl: 'https://www.hit-u.ac.jp/admission/',
    notes: '일반선발 사회과학 과목·조사서를 학부 요강에서 확인.',
    verifiedAt: '2026-08',
  },
  {
    id: 'meiji-general-hum',
    univ: '메이지대학',
    facultyHint: '일반선발·문과(사립)',
    track: 'general',
    field: 'humanities',
    admissionUrl: 'https://www.meiji.ac.jp/exam/',
    notes: '사립 일반선발·유학생 전형을 구분해 해당 학부 요강을 연다.',
    verifiedAt: '2026-08',
  },
  {
    id: 'aoyama-general-hum',
    univ: '아오야마학원대학',
    facultyHint: '일반선발·문과(사립)',
    track: 'general',
    field: 'humanities',
    admissionUrl: 'https://www.aoyama.ac.jp/admission/',
    notes: '학부·전형별 요강에서 과목·영어 요건을 확인.',
    verifiedAt: '2026-08',
  },
  // —— MEXT (대사관·Study in Japan만; 대학별 국비 URL 남발 금지) ——
  {
    id: 'embassy-mext',
    univ: '주한일본대사관',
    facultyHint: '국비(학부) 공고',
    track: 'mext',
    field: 'stem',
    admissionUrl: 'https://www.kr.emb-japan.go.jp/itpr_ko/study_government.html',
    notes: '연도별 모집 공고·일정이 최신 근거. 계열과 무관하게 공고 원문 우선.',
    verifiedAt: '2026-08',
  },
  {
    id: 'studyinjapan-mext',
    univ: 'Study in Japan',
    facultyHint: 'MEXT 학부 Embassy Recommendation',
    track: 'mext',
    field: 'humanities',
    admissionUrl:
      'https://www.studyinjapan.go.jp/en/smap-stopj-applications-undergraduate.html',
    notes: '대사관 추천 학부 루트 개요·양식. 한국 공고와 함께 본다.',
    verifiedAt: '2026-08',
  },
  {
    id: 'mext-exam-portal',
    univ: 'MEXT 국비 시험(과거문제 등)',
    facultyHint: '국비 학부 선발 참고',
    track: 'mext',
    field: 'medicine',
    admissionUrl: 'https://www.studyinjapan.go.jp/en/planning/scholarship/application/examination/index.html',
    notes: '선발 시험·과거문제 안내. 연도 공고와 함께 확인.',
    verifiedAt: '2026-08',
  },
];

export function examplesForIds(ids = []) {
  return ids.map((id) => programExamples.find((e) => e.id === id)).filter(Boolean);
}
